import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LanguageLoader } from '../../assets/languages';
import { useParams } from "react-router-dom";
import FieldContainer from './FieldContainer';
import Fields from './Fields';
import Dropdown from './Dropdown';
import FormatValue from './FormatValues';
import { DateFormat, Toastify } from '../utils';
import { SetPortalPreferencesAPI } from '../../services';
import { SetUserPreferences } from '../../redux/actions/user';
import { settings } from '../../services/config';

const AdvancedFilter = ({fields, callback}) =>
{
	const defaultFilter = {id: '', field: '', operator: '', value: '', label: ''};
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const {module} = useParams();
	const dispatch = useDispatch();
	const [isOpen, SetIsOpen] = useState(false);
	const [creation, SetCreation] = useState(false);
	const [selectedFilter, SetSelectedFilter] = useState(defaultFilter);
	const [filters, SetFilters] = useState(preferences.filters && preferences.filters[module] ? preferences.filters[module] : []);
	
	let moduleFields = {'': language.ERROR.SELECT_A_FIELD};
	Object.values(fields).filter(field => field.list).forEach(field => { moduleFields[field.name] = field.label[preferences.language]});
	
	useEffect(() =>
	{
		if(callback)
		{
			callback(filters);
		}
	// eslint-disable-next-line
	}, [filters]);
	
	
	useEffect(() =>
	{
		SetFilters(preferences.filters && preferences.filters[module] ? preferences.filters[module] : []);
	// eslint-disable-next-line
	}, [module]);
	
	
	useEffect(() =>
	{
		if(!isOpen)
		{
			SetCreation(false);
		}
	// eslint-disable-next-line
	}, [isOpen]);



	const SaveFilter = async () =>
	{
		if(selectedFilter && selectedFilter.field && selectedFilter.operator && selectedFilter.value)
		{
			const isExist = Object.keys(filters).filter(index => filters[index].id === selectedFilter.id);
			let moduleFilters = [];
			if(isExist && isExist.length)
			{
				const filterKey = isExist[0];
				moduleFilters = [...filters];
				moduleFilters[filterKey] = selectedFilter;
			}
			else
			{
				moduleFilters = [...filters, selectedFilter];
			}
			SetAdvancedFilters(moduleFilters);
		}
		else
		{
			Toastify(language.ERROR.WRONG_DATA);
		}
	}

	const Operators = (field) =>
	{
		const choices = {
			'base': {
				'equal': language.OPERATORS.EQUAL,
				'like': language.OPERATORS.LIKE,
				'not_equal': language.OPERATORS.NOT_EQUAL,
			},
			'id': {
				'equal': language.OPERATORS.EQUAL,
				'not_equal': language.OPERATORS.NOT_EQUAL,
			},
			'dropdown': {
				'equal': language.OPERATORS.EQUAL,
				'not_equal': language.OPERATORS.NOT_EQUAL,
				'in': language.OPERATORS.IN,
				'not_in': language.OPERATORS.NOT_IN,
			},
			'date': {
				'date_range': language.OPERATORS.DATE_RANGE,
				'equal': language.OPERATORS.EQUAL,
				'not_equal': language.OPERATORS.NOT_EQUAL,
				'greater': language.OPERATORS.AFTER,
				'greater_equal': language.OPERATORS.AFTER_EQUAL,
				'less': language.OPERATORS.BEFORE,
				'less_equal': language.OPERATORS.BEFORE_EQUAL,
			},
			'number': {
				'equal': language.OPERATORS.EQUAL,
				'not_equal': language.OPERATORS.NOT_EQUAL,
				'greater': language.OPERATORS.GREATER,
				'greater_equal': language.OPERATORS.GREATER_EQUAL,
				'less': language.OPERATORS.LESS,
				'less_equal': language.OPERATORS.LESS_EQUAL,
			}
		};
		let options = {};
		if(fields[field])
		{
			switch(fields[field].type)
			{
				case 'date':
				case "datetime":
					options = choices.date;
					break;
				case 'int':
				case 'currency':
				case 'bigint':
				case 'decimal':
					options = choices.number;
					break;
				case 'enum':
				case 'multienum':
					options = choices.dropdown;
					break;
				case 'tree':
				case 'relate':
					options = choices.id;
					break;
				default:
					options = choices.base;
					break;
			}
		}
		return options;
	}
	
	const HandleCreation = async (filterID) =>
	{
		if(filterID)
		{
			const filter = filters.filter(field => field.id === filterID);
			if(filter && filter[0])
			{
				/* EDIT */
				/* HIDE AND SHOW CREATION BECAUSE DROPDOWN VALUES WERE NOT CHANGED */
				HandleCreation(false).then(() => SetCreation(true));
				if((fields[filter[0].field].type === 'date' || fields[filter[0].field].type === 'datetime') && filter[0].operator !== 'date_range')
				{
					filter[0].value = DateFormat(filter[0].value);
				}

				SetSelectedFilter(filter[0]);
			}
			else
			{
				/* CREATE */
				/* HIDE AND SHOW CREATION BECAUSE DROPDOWN VALUES WERE NOT CHANGED */
				HandleCreation(false).then(() => SetCreation(true));
				SetSelectedFilter(defaultFilter);
			}
		}
		else
		{
			/* CLOSE */
			SetCreation(false);
			SetSelectedFilter(defaultFilter);
		}
	}

	const Remove = async (id) =>
	{
		const moduleFilters = [...filters];
		const indexToRemove = moduleFilters.findIndex(filter => filter.id === id);
		if (indexToRemove !== -1)
		{
			const itemToRemove = moduleFilters[indexToRemove];
			if(itemToRemove.id && itemToRemove.id.toString().length)
			{
				moduleFilters.splice(indexToRemove, 1);
				SetAdvancedFilters(moduleFilters);
			}
		}
	}

	const SetAdvancedFilters = async (filters) =>
	{
		let filterArray = {};
		filterArray[module] = filters;
		const APIResponse = await SetPortalPreferencesAPI({filters: filterArray});
		if(Object.keys(APIResponse).length && APIResponse && APIResponse.filters[module])
		{
			if(!APIResponse.language || !APIResponse.language.length)
			{
				APIResponse.language = 'fa_IR';
			}
			dispatch(SetUserPreferences(APIResponse)).then(() => {SetFilters(APIResponse.filters[module]); HandleCreation(false);});
		}
	}

	return <>
	<FieldContainer className={'relative text-end'}>
		<div className='button btn secondary mt-6 inline-block cursor-pointer text-center w-full md:w-auto' onClick={() => SetIsOpen(!isOpen)}>
			<i className='fa fa-filter me-2'></i>
			<span>{language.FILTER.ADVANCED_FILTERS}</span>
			<span className='p-2 bg-primary text-secondaryFont rounded-full ms-3 w-6 h-6 !p-1 inline-block text-center'>{filters.length}</span>
		</div>
	</FieldContainer>
	<div className={`fixed flex flex-col h-screen wrapper top-0 z-30 w-full md:w-1/5 start-full ${isOpen ? ' translate-x-full' : ' translate-x-0'}`}>
		<div className='mb-4 flex justify-between px-2 order-1'>
			<div className='flex items-center'>
				<i className='fa fa-times me-4 text-xl hover:text-primary cursor-pointer' onClick={() => SetIsOpen(false)}></i>
				<span>{language.FILTER.ADVANCED_FILTERS}</span>
			</div>
			<span className='p-2 bg-primary text-white rounded-full ms-3 w-6 h-6 !p-1 inline-block text-center text-sm'>{filters.length}</span>
		</div>
		<FieldContainer className={'w-full relative order-2'}>
			<button className='btn w-full' onClick={() => HandleCreation(true)}><i className='fa fa-plus-circle me-2'></i>{language.FILTER.NEW_FILTER}</button>
		</FieldContainer>
		<div className='grow overflow-auto order-4'>
		{filters.length > 0 ? filters.map((filter, index) =>
		{
			if(!fields[filter.field])
			{
				return null;
			}
			/* CHANGE TYPE OF FIELD BASED ON OPERATOR */
			const vardef = {...fields[filter.field]};
			if((vardef.type === 'enum' || vardef.type === 'multienum') && (filter.operator === 'in' || filter.operator === 'not_in'))
			{
				vardef.type = 'multienum';
			}
			/* FILTER COMPONENT */
			return <div key={index} className='relative w-full text-start flex flex-wrap justify-between items-center text-sm border border-primaryBorder mb-2 last:mb-0 rounded-lg hover:border-primary'>
			<div onClick={() => HandleCreation(filter.id)} className='grow py-3 px-3 cursor-pointer'>
				<div className='text-sm text-tertiaryFont mb-2'>
					<span>{vardef.label[preferences.language]}</span>
					<i className='fa fa-left-right mx-2'></i>
					<span>{Operators(filter.field)[filter.operator]}</span>
				</div>
				<div className='text-base flex gap-2'>
					{/* <span>{Operators(filter.field)[filter.operator]}</span> */}
					<span className='font-bold text-s'>
						<FormatValue
							value={filter.value}
							vardef={vardef}
							format={true}
							related_to={filter.label && filter.label.length ? filter.label : filter.value}
						/>
					</span>
				</div>
			</div>
			<div className='text-lg text-tertiaryFont cursor-pointer'>
				<i className='fa fa-pencil p-3 hover:text-primary' onClick={() => HandleCreation(filter.id)}></i>
				<i className='fa fa-trash-alt p-3 hover:text-danger' onClick={() => Remove(filter.id)}></i>
			</div>
		</div>
		}) : <div className='w-full flex flex-col items-center text-sm mb-2 rounded-lg py-5 px-3'>
			<i className='fa fa-exclamation-triangle text-3xl mb-3 text-warning'></i>
			<span>{language.ERROR.NOTHING_TO_SHOW}</span>
		</div>}
		</div>
		<div className='mb-5 order-4'>
			<button className={`btn secondary !border-danger !text-danger w-full ${!filters.length ? 'disabled' : null}`} onClick={() => SetAdvancedFilters([])}>
				<i className='fa fa-trash-alt me-5'></i>
				<span>{language.FILTER.FILTER_CLEANER}</span>
			</button>
		</div>
		{creation ? 
		<div className='flex flex-wrap text-start border-primaryBorder z-20 top-16 order-3 md:order-6 md:me-2 md:fixed md:end-full md:wrapper md:border md:mt-0 md:w-[30rem]'>
			<FieldContainer label={language.FIELD}>
				<Dropdown
					testing={true}
					options={moduleFields}
					defaultValue={selectedFilter.field}
					onChange={(selected) => SetSelectedFilter({...selectedFilter, field: selected, value: ''})}
				/>
			</FieldContainer>
			<FieldContainer label={language.OPERATOR}>
				<Dropdown
					options={Operators(selectedFilter.field)}
					defaultValue={selectedFilter.operator || Object.keys(Operators(selectedFilter.field))[0]}
					onChange={(selected) => SetSelectedFilter({...selectedFilter, operator: selected})}
				/>
			</FieldContainer>
			{selectedFilter.field.length ? 
				selectedFilter.operator !== 'date_range' ? <Fields
					subpanel={false}
					module={module}
					field={selectedFilter.field}
					customization={{className: 'w-full', multiple: (selectedFilter.operator === 'in' || selectedFilter.operator === 'not_in'), accessible: true}}
					value={selectedFilter.value}
					related_to={selectedFilter.label ? selectedFilter.label : null}
					Callback={(val) => SetSelectedFilter({...selectedFilter, value: val})}/>
				: <FieldContainer className='w-full' label={language.VALUE}><Dropdown defaultValue={selectedFilter.value} onChange={(val) => SetSelectedFilter({...selectedFilter, value: val})} multiple={false} options={settings.dropdowns.dates} disabled={false}/></FieldContainer>
			: <FieldContainer className='w-full' label={language.VALUE}><input type="text" placeholder={language.ERROR.SELECT_A_FIELD} disabled/></FieldContainer>}
			<button className="w-full btn" onClick={SaveFilter}>{language.FILTER.SUBMIT_FILTER}</button>
			<button className="w-full btn secondary !border-danger !text-danger" onClick={() => SetCreation(false)}>{language.CANCEL}</button>
		</div> : null}
	</div>
	{isOpen ? <div className='absolute w-full h-full top-0 z-20' onClick={() => {SetIsOpen(false); HandleCreation(false);}}></div> : null }
	</>
};

export default AdvancedFilter;